/**
 * A list of colors.
 */
export enum NamedColorsHEX {
  DarkSeaTurquoise = '#13A8A0',
  LightSeaGreen = '#20A4C8',
  LightSeaTurquoise = '#17D3C9',
  LightSlateGray = '#9182AC',
  PantoneAquaSky = '#7BC4C4',
  PantoneBlueIris = '#5A5B9F',
  PantoneBlueTurquoise = '#53B0AE',
  PantoneCanoliCream = '#F0EFE2',
  PantoneCeruleanBlue = '#98B2D1',
  PantoneChiliPepper = '#9B1B30',
  PantoneClassicBlue = '#0F4C81',
  PantoneCoconutMilk = '#F0EDE5',
  PantoneCoolGray1C = '#D9D9D6',
  PantoneEmerald = '#009474',
  PantoneFuchsiaRose = '#C74375',
  PantoneGreenery = '#88B04B',
  PantoneHoneysuckle = '#D94F6F',
  PantoneLivingCoral = '#FF6F61',
  PantoneMarsala = '#964E4C',
  PantoneMimosa = '#F0C15A',
  PantonePeachQuarts = '#F5B895',
  PantonePixie = '#CEA8BF',
  PantoneRadiantOrchid = '#AD5E99',
  PantoneRoseQuartz = '#F7CAC9',
  PantoneSandDollar = '#DECDBE',
  PantoneSerenity = '#91A8D0',
  PantoneTangerineTango = '#DD4024',
  PantoneTigerlily = '#E2583E',
  PantoneTrueRed = '#BF1932',
  PantoneTurquoise = '#45B5AA',
  PantoneUltraViolet = '#5F4B8B',
  SandyBrown = '#F3A347',
  SlateBlue = '#505BD3',
  KahPurple = '#4F3978',
}

export const getRandomNamedColor = (exceptions: string[] = []): string => {
  const arrayOfColors = Object.values(NamedColorsHEX);
  const randomInteger = Math.ceil(Math.random() * 1000 * arrayOfColors.length);

  const selectedColor = arrayOfColors[randomInteger % arrayOfColors.length];

  if (exceptions.includes(selectedColor))
    return getRandomNamedColor(exceptions);

  return selectedColor;
};

export const BORDER_COLOR = '#9182AC';
export const BORDER_RADIUS_PX = 4;
export const FONT_SIZE_PX = 15;

/**
 * Screen resolutions for breakpoint purposes.
 */
export enum ScreenSizesPx {
  small = 576,
  medium = 768,
  large = 992,
  extraLarge = 1200,
}
